"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.to-string");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerLayout = registerLayout;
exports.getLayout = getLayout;
exports.clearLayoutEngines = clearLayoutEngines;
exports.getLayoutTypes = getLayoutTypes;

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/keys"));

var _baseRegistry = require("./base-registry");

var _createRegistry = (0, _baseRegistry.createRegistry)(),
    register = _createRegistry.register,
    get = _createRegistry.get,
    clear = _createRegistry.clear,
    keys = (0, _keys.default)(_createRegistry);

function registerLayout(type, layout) {
  return register(type.toString(), layout);
}

function getLayout(type) {
  var engine = get(type.toString());

  if (!engine) {
    throw new Error("Item engine: ".concat(type, " not found"));
  }

  return engine;
}

function clearLayoutEngines() {
  clear();
}

function getLayoutTypes() {
  return keys();
}
